import { Helmet } from "react-helmet";
import imgOne from "../images/Section-5/dr_1.webp";
import imgTwo from "../images/Section-5/dr_2.webp";
import imgThree from "../images/Section-5/dr_3.webp";

export default function SectionFive() {
  return (
    <div className="w-full relative overflow-hidden font-aldrich">
      <Helmet>
        <title>Testimonials | See What Our Clients Say</title>
        <meta
          name="description"
          content="Read testimonials from top medical professionals about how DUMOSH has transformed their practice with expert marketing solutions."
        />
        <meta
          name="keywords"
          content="testimonials, doctor reviews, medical marketing, patient acquisition, DUMOSH success stories"
        />
        <meta
          property="og:title"
          content="Testimonials | See What Our Clients Say"
        />
        <meta
          property="og:description"
          content="Discover how DUMOSH has helped doctors achieve success with packed appointment schedules and strategic marketing solutions."
        />
        <meta property="og:type" content="website" />
        <link rel="preload" as="image" href={imgOne} />
        <link rel="preload" as="image" href={imgTwo} />
        <link rel="preload" as="image" href={imgThree} />
      </Helmet>
      <div className="max-w-2xl md:max-w-full lg:mx-[2rem] py-6 px-2 flex flex-col space-y-8 bg-white ">
        {/* Main Section */}
        <div className="flex flex-col justify-center items-center">
          <div className="w-full flex flex-col justify-center items-start">
            <h2 className="text-xl md:text-3xl lg:text-4xl xl:text-5xl text-left text-black">
              Testimonials
            </h2>
          </div>
          {/* First */}
          <div className="flex flex-col justify-center items-center w-full my-2">
            <div className="w-full grid grid-cols-3">
              <div className="justify-self-center">
                <img
                  src={imgOne}
                  alt=""
                  className="w-100 hover:scale-105 transition-transform duration-300 border border-black"
                />
              </div>
              <div className="flex flex-col justify-center p-2 bg-[#D9D9D969] col-span-2 w-full xl:space-y-10">
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-black">
                  Dumosh has been instrumental in elevating my hospital&apos;s
                  online presence and connecting with the right audience. Their
                  strategic campaigns and engaging content have boosted my
                  visibility and credibility. More than service providers,
                  they&apos;re true partners in success. Highly recommend.
                </p>
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-[#FF2020]">
                  Dr. Neha Rathi
                </p>
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-black">
                  Infertility Expert, OBGY
                </p>
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-black">
                  Owner : Dr. Rathi&apos;s Bright Hope IVF, Mumbai{" "}
                </p>
              </div>
            </div>
          </div>
          {/* Second */}
          <div className="flex flex-col justify-center items-center w-full my-2">
            <div className="w-full grid grid-cols-3">
              <div className="justify-self-center">
                <img
                  src={imgTwo}
                  alt=""
                  className="w-100 hover:scale-105 transition-transform duration-300 border border-black"
                />
              </div>
              <div className="flex flex-col justify-center p-2 bg-[#D9D9D969] col-span-2 w-full xl:space-y-10">
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-black">
                  We&apos;ve been working with Dumosh for social media and paid
                  promotions, and their team, led by Mr. Shadab, is exceptional.
                  Their prompt, client - focused, and deliver great results.
                </p>
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-[#FF2020]">
                  Dr. Rasika Pise Gulhane
                </p>
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-black">
                  Consultant Obstetrician, Gynaecologist &amp; Infertility
                  Specialist{" "}
                </p>
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-black">
                  Co-Founder : Medigrace Hospital, Nagpur{" "}
                </p>
              </div>
            </div>
          </div>
          {/* Third */}
          <div className="flex flex-col justify-center items-center w-full my-2">
            <div className="w-full grid grid-cols-3">
              <div className="justify-self-center">
                <img
                  src={imgThree}
                  alt=""
                  className="w-100 hover:scale-105 transition-transform duration-300 border border-black"
                />
              </div>
              <div className="flex flex-col justify-center p-2 bg-[#D9D9D969] col-span-2 w-full xl:space-y-6">
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-black">
                  Dumosh has been fantastic in delivering results. Their team is
                  proactive, and we are happy with their marketing and
                  tele-calling support. Highly recommend.
                </p>
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-[#FF2020]">
                  Dr. Adnan Shaikh
                </p>
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-black">
                  MBBA, Radiology &amp; Electrology
                </p>
                <p className="text-[10px] md:text-sm lg:text-lg xl:text-3xl text-left text-black">
                  MD : Healthspring, Mumbai{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
